<template>
  <div class="content-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>
            {{ headerText }}
            <hr :class="noContent ? 'no-content' : ''" />
          </h1>
        </div>

        <div class="col-12 prose">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerText: String,
    noContent: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

h1 {
  margin-bottom: 0;
}

.content-page {
  padding-top: 64px;
  padding-bottom: 64px;

  background-color: $clr-theme-black;
  color: white;

  & p {
    @media (min-width: $sm-md-breakpoint) {
      font-size: 1.2rem;
    }
  }
}

.prose {
  a {
    color: $white;
  }

  strong {
    font-weight: 600;
  }

  p {
    margin-top: 1.875em;
    margin-bottom: 1.875em;
  }

  ol,
  ul {
    margin-top: 1.875em;
    margin-bottom: 1.875em;
  }

  li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
}

.no-content {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ContentPage.vue